// make sure color is included in the library.
const styleguideHasKey = (key, arr, def) => {
  let keyCheck
  if (key in arr) keyCheck = key
  else keyCheck = def
  return keyCheck
}

export default styleguideHasKey
